/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Open_Menu_DailyInputs */

const bn_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আজকের দিনের জন্য মেনু খুলুন.`)
};

const de_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen Sie die Speisekarte für den heutigen Tag.`)
};

const el_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανοίξτε το μενού για το σημερινό καθημερινό.`)
};

const en_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the menu for today's daily.`)
};

const es_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre el menú del día de hoy.`)
};

const fr_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrez le menu pour le quotidien d’aujourd’hui.`)
};

const hi_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आज के दैनिक के लिए मेनू खोलें.`)
};

const hu_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyissa meg a mai napi menüt.`)
};

const id_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka menu harian hari ini.`)
};

const it_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il menu del quotidiano di oggi.`)
};

const ja_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日の日替わりメニューを開きます。`)
};

const ko_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘의 일일 메뉴를 엽니다.`)
};

const nl_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open het menu voor de dag van vandaag.`)
};

const pl_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz menu dzisiejszego dziennika.`)
};

const pt_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra o menu do dia a dia de hoje.`)
};

const ru_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте меню на сегодняшний день.`)
};

const sv_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öppna menyn för dagens vardag.`)
};

const tr_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugünün günlük menüsünü açın.`)
};

const uk_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрийте меню на сьогоднішній день.`)
};

const vi_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở thực đơn cho ngày hôm nay.`)
};

const zh_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开今天的每日菜单。`)
};

const zh_hant_game_open_menu_daily = /** @type {(inputs: Game_Open_Menu_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打開今天的每日菜單。`)
};

/**
* | output |
* | --- |
* | "Open the menu for today's daily." |
*
* @param {Game_Open_Menu_DailyInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_open_menu_daily = /** @type {((inputs?: Game_Open_Menu_DailyInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Open_Menu_DailyInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_open_menu_daily(inputs)
	if (locale === "de") return de_game_open_menu_daily(inputs)
	if (locale === "el") return el_game_open_menu_daily(inputs)
	if (locale === "en") return en_game_open_menu_daily(inputs)
	if (locale === "es") return es_game_open_menu_daily(inputs)
	if (locale === "fr") return fr_game_open_menu_daily(inputs)
	if (locale === "hi") return hi_game_open_menu_daily(inputs)
	if (locale === "hu") return hu_game_open_menu_daily(inputs)
	if (locale === "id") return id_game_open_menu_daily(inputs)
	if (locale === "it") return it_game_open_menu_daily(inputs)
	if (locale === "ja") return ja_game_open_menu_daily(inputs)
	if (locale === "ko") return ko_game_open_menu_daily(inputs)
	if (locale === "nl") return nl_game_open_menu_daily(inputs)
	if (locale === "pl") return pl_game_open_menu_daily(inputs)
	if (locale === "pt") return pt_game_open_menu_daily(inputs)
	if (locale === "ru") return ru_game_open_menu_daily(inputs)
	if (locale === "sv") return sv_game_open_menu_daily(inputs)
	if (locale === "tr") return tr_game_open_menu_daily(inputs)
	if (locale === "uk") return uk_game_open_menu_daily(inputs)
	if (locale === "vi") return vi_game_open_menu_daily(inputs)
	if (locale === "zh") return zh_game_open_menu_daily(inputs)
	return zh_hant_game_open_menu_daily(inputs)
});